<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Penerimaan Kas Pusat</h5>
            </template>
            <div class="big-filter-label filter-form-wrapper mb-3">
                <b-row class="align-items-start justify-content-between">
                    <b-col md="12" lg="9">
                        <b-row>
                            <b-col>

                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col class="filter-btn-add-wrapper">
                        <b-button @click="()=>{ (checked.length == 0) ? $helper.toastErr(this,'Mohon pilih data yang akan di approve!') :$bvModal.show('confirm-terima')}" class="mb-3" variant="pgiBtn"
                            name="kasMutasiHoAddBtn">Terima Semua {{ (checked.length != 0) ? checked.length :
                                '' }}</b-button>
                    </b-col>
                </b-row>

            </div>
            <b-table bordered hover show-empty :busy="isBusy" :items="kasMutasi" :fields="fields" :no-local-sorting="false"
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data kas mutasi.
                </template>
                <template v-slot:cell(nominal)="row">
                    <div class="text-right no-wrap" v-if="row.item.nominal !== null">Rp.
                        {{ $helper.addThousandSeparator(row.item.nominal) }} </div>
                    <div class="text-right no-wrap" v-else>{{ $helper.addThousandSeparator(row.item.nominal) }} </div>
                </template>
                <template v-slot:cell(tanggalPembuatan)="row">
                    <div>{{ $helper.changeDateFormat(row.item.tanggalPembuatan) }}</div>
                    <div class="smallText text-muted">{{ $helper.changeDateFormatGetHour(row.item.tanggalPembuatan) }}</div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge variant="warning" v-if="row.item.status.id == 1">{{ row.item.status.name }}</b-badge>
                    <b-badge variant="primary" v-else-if="row.item.status.id == 2">{{ row.item.status.name }}</b-badge>
                    <b-badge variant="success" v-else-if="row.item.status.id == 3">{{ row.item.status.name }}</b-badge>
                    <b-badge variant="danger" v-else-if="row.item.status.id == 4">{{ row.item.status.name }}</b-badge>
                    <b-badge v-else>{{ row.item.status.name }}</b-badge>
                </template>
                <template v-slot:head(status)>
                    Status
                    <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')" />
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-form-checkbox-group class="checkbox-group" name="referensi" stacked>
                            <b-form-checkbox v-model="checked" :value="row.item.id">
                            </b-form-checkbox>
                        </b-form-checkbox-group>
                    </div>
                </template>
            </b-table>

            <!-- <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0" v-model="currentPage" :total-rows="rows" :per-page="perPage"
                    aria-controls="my-table" @input="onPageChange"></b-pagination>
            </div> -->
        </b-card>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">PENDING</h6>
                <p class="smallText mb-0">Kas mutasi masih menunggu cabang pengirim "Dari" untuk melakukan pengiriman.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">TERKIRIM</h6>
                <p class="smallText mb-0">Kas mutasi sudah dikirimkan dari cabang pengirim "Dari".</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DITERIMA</h6>
                <p class="smallText mb-0">Kas mutasi sudah diterima oleh cabang penerima. Kas cabang pengirim dan penerima sudah disesuaikan sesuai dengan nominal mutasi.</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">BATAL</h6>
                <p class="smallText mb-0">Kas mutasi sudah dibatalkan dan tidak dapat diproses lagi.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
        <ModalConfirm id="confirm-terima" title="Konfirmasi Terima" :isSubmitting="isBusy"
            :desc='"Lakukan penerimaan untuk " + checked.length + " mutasi kas terpilih?"' @submit="onSubmit" />

    </div>
</template>

<script>
export default {
    name: 'penerimaanKasPusat',
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            role: null,
            credential: null,
            checked: [],
            kasMutasi: [],
            fields: [
                { key: "dari.name", label: "Dari" },
                { key: "tujuan.name", label: "Ke" },
                { key: "createdBy.name", label: "Dibuat oleh" },
                { key: "nominal", label: "Nominal" },
                { key: "tanggalPembuatan", label: "Tanggal" },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi" },
            ],
            options: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],
            status: [
                { id: 1, name: 'Pending' },
                { id: 2, name: 'Terkirim' },
                { id: 3, name: 'Diterima' },
                { id: 4, name: 'Batal' }
            ],
            loading: false,
        }
    },
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init() {
            this.initStatus = 0

            let getKasMutasi = this.$axios.get("cabang/kas/mutasi-terima-pusat").then(response => {
                this.kasMutasi = response.data


                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getKasMutasi]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
                .catch(error => {
                    console.log(error)
                    this.initStatus = -1
                })

        },


        //----------------- Fungsi Ambil Data Kas Mutasi -----------------

        getKasMutasi() {
            this.toggleBusy()
            this.kasMutasi = []

            this.$axios.get("cabang/kas/mutasi-terima-pusat").then(response => {
                this.kasMutasi = response.data
                this.toggleBusy()
                this.loading = false
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                    this.toggleBusy()
                    this.loading = false
                })
        },

        onSubmit() {
            this.toggleBusy()
            this.kasMutasi = []

            this.$axios.post("cabang/kas/approve-terima-bulk-pusat?mutasiIds=" + this.checked).then(() => {
                this.toggleBusy()
                this.loading = false
                this.$helper.toastSucc(this, "Data berhasil di approve!")
                this.getKasMutasi()
                this.checked = 0
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                    this.toggleBusy()
                    this.loading = false
                })
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

    },
    created() {
        this.init()
    }
}
</script>
